import React from 'react'
import logo from '../assets/logo/prolex_logo.png'
export default function Logo({onClick}) {
  return (
    <div className='logo' onClick={onClick}>
        <img src={logo} alt="Logo" className='logo-img'/>
    </div>
  )
}
